import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  background-color: ${colors.backgroundPrimary};
  color: ${colors.textPrimary};
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  padding: 35px 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 25px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  font-size: ${fontSize.m};
  font-weight: 500;
  margin-bottom: 22px;
  letter-spacing: 0.5px;
  color: ${colors.textPrimary};
  position: relative;
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 35px;
    height: 2px;
    background-color: ${colors.accent};
  }
`;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const IconWrapper = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: ${colors.backgroundSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.25s ease;
`;

const ContactText = styled.span`
  font-size: ${fontSize.s};
  color: ${colors.textSecondary};
  line-height: 1.5;
`;

const ContactItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  transition: all 0.25s ease;
  cursor: pointer;

  &:hover {
    ${IconWrapper} {
      background-color: ${colors.black};
    }
    ${ContactText} {
      color: ${colors.black};
    }
    svg {
      fill: ${colors.backgroundPrimary};
    }
  }
`;

const SocialContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 15px;
  flex-wrap: wrap;
`;

const SocialIcon = styled.a`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: ${colors.backgroundSecondary};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    svg {
      fill: ${colors.backgroundPrimary};
    }
  }

  /* Instagram */
  &:nth-child(1):hover {
    background: linear-gradient(
      45deg,
      #f09433,
      #e6683c,
      #dc2743,
      #cc2366,
      #bc1888
    );
  }

  /* TikTok */
  &:nth-child(2):hover {
    background-color: #000000;
  }

  /* Facebook */
  &:nth-child(3):hover {
    background-color: #3b5998;
  }

  /* Twitter */
  &:nth-child(4):hover {
    background-color: #1da1f2;
  }

  /* YouTube */
  &:nth-child(5):hover {
    background-color: #ff0000;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    ${colors.borderLight},
    transparent
  );
  margin: 25px 0;
`;

const HoursList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const HourItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${fontSize.s};
  color: ${colors.textSecondary};
`;

const Day = styled.span`
  font-weight: 400;
`;

const Time = styled.span`
  font-weight: 400;
`;

const QuickAction = styled.div`
  margin-top: 20px;
  padding: 15px;
  background-color: ${colors.backgroundSecondary};
  border-radius: 8px;

  p {
    margin: 0 0 12px 0;
    font-size: ${fontSize.s};
    color: ${colors.textSecondary};
  }
`;

const Button = styled.button`
  background-color: ${colors.accent};
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: ${fontSize.s};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
`;

function ContactBanner() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Container>
        <Grid>
          <Column>
            <Title>Contact Methods</Title>
            <ContactList>
              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                  </svg>
                </IconWrapper>
                <ContactText>walletmenswear@gmail.com</ContactText>
              </ContactItem>

              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                </IconWrapper>
                <ContactText>+977 9867071416</ContactText>
              </ContactItem>
              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                </IconWrapper>
                <ContactText>Telephone : 01-4534011</ContactText>
              </ContactItem>
              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </IconWrapper>
                <ContactText>
                  Dhumbarahi Khahare, Near Pipalbot, KTM, Nepal
                </ContactText>
              </ContactItem>
            </ContactList>
          </Column>

          <Column>
            <Title>Business Hours</Title>
            <HoursList>
              <HourItem>
                <Day>Monday - Friday</Day>
                <Time>10:00 AM - 8:00 PM</Time>
              </HourItem>
              <HourItem>
                <Day>Saturday</Day>
                <Time>10:00 AM - 8:00 PM</Time>
              </HourItem>
              <HourItem>
                <Day>Sunday</Day>
                <Time>10:00 AM - 8:00 PM</Time>
              </HourItem>
            </HoursList>

            <Divider />
          </Column>
          <Column>
            <Title>Follow Us</Title>
            <SocialContainer>
              <SocialIcon
                href="https://www.instagram.com/walletmenswear"
                target="_blank"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#555"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </SocialIcon>

              <SocialIcon
                href="https://www.tiktok.com/@walletmenswear"
                target="_blank"
                aria-label="TikTok"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#555"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
                </svg>
              </SocialIcon>

              <SocialIcon
                href="https://www.facebook.com/profile.php?id=100070757382584"
                target="_blank"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#555"
                >
                  <path d="M20.9 2H3.1C2.5 2 2 2.5 2 3.1v17.8c0 .6.5 1.1 1.1 1.1h9.6v-7.7h-2.6v-3h2.6V9.2c0-2.6 1.6-4 3.9-4 1.1 0 2.1.1 2.3.1v2.7h-1.6c-1.3 0-1.5.6-1.5 1.5v1.9h3l-.4 3h-2.6V22h5.1c.6 0 1.1-.5 1.1-1.1V3.1c0-.6-.5-1.1-1.1-1.1z" />
                </svg>
              </SocialIcon>

              <SocialIcon
                href="https://twitter.com"
                target="_blank"
                aria-label="Twitter"
              ></SocialIcon>

              {/* <SocialIcon
                href="https://youtube.com"
                target="_blank"
                aria-label="YouTube"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="#555"
                >
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                </svg>
              </SocialIcon> */}
            </SocialContainer>
          </Column>

          {/* <Column>
            <Title>Quick Help</Title>
            <ContactList>
              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                  </svg>
                </IconWrapper>
                <ContactText>FAQ & Help Center</ContactText>
              </ContactItem>

              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                  </svg>
                </IconWrapper>
                <ContactText>Send us a message</ContactText>
              </ContactItem>

              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                  </svg>
                </IconWrapper>
                <ContactText>Wishlist & Favorites</ContactText>
              </ContactItem>

              <ContactItem>
                <IconWrapper>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="#555"
                  >
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
                  </svg>
                </IconWrapper>
                <ContactText>Track Your Order</ContactText>
              </ContactItem>
            </ContactList>

            <Divider />
          </Column> */}
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default ContactBanner;
